import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ChangeRack = Loadable(
  lazy(() => import("features/changeRack/components/ChangeRack"))
);

const routes = {
  path: "changeRack",
  children: [{ path: "", element: <ChangeRack /> }],
};

export default routes;
